 var ALGOLIA_INSIGHTS_SRC = "https://cdn.jsdelivr.net/npm/search-insights@2.17.3/dist/search-insights.min.js";

  !function(e,a,t,n,s,i,c){e.AlgoliaAnalyticsObject=s,e[s]=e[s]||function(){
  (e[s].queue=e[s].queue||[]).push(arguments)},e[s].version=(n.match(/@([^\/]+)\/?/) || [])[1],i=a.createElement(t),c=a.getElementsByTagName(t)[0],
  i.async=1,i.src=n,c.parentNode.insertBefore(i,c)
  }(window,document,"script",ALGOLIA_INSIGHTS_SRC,"aa");

aa('init', {
  appId:  window.algoliaShopify.config.app_id,
  apiKey: window.algoliaShopify.config.search_api_key,
  useCookie: true,
});
aa('getUserToken', {}, (err, userToken) => {
  if (err) {
    console.error(err);
    return;
  }
  const locale = window.Shopify.locale || 'en';
  let indexName;

  if (locale === 'ar') {   
    indexName = 'shopify_products_saudi_arabia_ar';
  } else {    
    indexName = `${window.algoliaShopify.config.index_prefix}products`;
  }

  // ── Write to the key ALL event-firing code reads from ──────────────────
  // The Insights SDK saves the token under 'algolia_analytics_options'
  // but every analytics function in the theme reads '_ALGOLIA_USER_TOKEN'.
  if (userToken) {
    localStorage.setItem('_ALGOLIA_USER_TOKEN', userToken);
  }
  // ──────────────────────────────────────────────────────────────────────

  const authenticatedUserToken = window.algoliaShopify.authenticatedUserToken || null;

  
  const configToSave = {
    app_id: window.algoliaShopify.config.app_id,
    search_api_key: window.algoliaShopify.config.search_api_key,
    index_name: indexName,
    user_token: userToken,
    authenticatedUserToken: authenticatedUserToken
  };
  
  
  localStorage.setItem('algolia_config', JSON.stringify(configToSave));

  
  // Save analytics options with userToken
  localStorage.setItem(
    'algolia_analytics_options',
    JSON.stringify({ userToken })
  );
});
